export function numberToWords(num, currency ="USD") {
    if (num > 9999999) {
        return "Número fora do intervalo";
    }

    const unidades = ["", "um", "dois", "três", "quatro", "cinco", "seis", "sete", "oito", "nove"];
    const especiais = ["dez", "onze", "doze", "treze", "quatorze", "quinze", "dezesseis", "dezessete", "dezoito", "dezenove"];
    const dezenas = ["", "", "vinte", "trinta", "quarenta", "cinquenta", "sessenta", "setenta", "oitenta", "noventa"];
    const centenas = ["", "cento", "duzentos", "trezentos", "quatrocentos", "quinhentos", "seiscentos", "setecentos", "oitocentos", "novecentos"];

    const currencyNames = {
        JPY: { singular: "IENE JAPONÊS", plural: "IENES JAPONESES", centPlural: "" }, // JPY has no cêntimos
        AOA: { singular: "KWANZA ANGOLANO", plural: "KWANZAS ANGOLANOS", centPlural: "CÊNTIMOS" },
        USD: { singular: "DÓLAR AMERICANO", plural: "DÓLARES AMERICANOS", centPlural: "CÊNTIMOS" },
        EUR: { singular: "EURO", plural: "EUROS", centPlural: "CÊNTIMOS" },
        MOP: { singular: "PATACA DE MACAU", plural: "PATACAS DE MACAU", centPlural: "AVOS" },
    };

    function lessThanThousandToWords(n) {
        let words = [];
        if (n === 100) return "cem";
        if (Math.floor(n / 100) > 0) words.push(centenas[Math.floor(n / 100)]);
        n %= 100;
        if (n >= 10 && n < 20) words.push(especiais[n - 10]);
        else {
            if (Math.floor(n / 10) > 0) words.push(dezenas[Math.floor(n / 10)]);
            if (n % 10 > 0) words.push(unidades[n % 10]);
        }
        return words.join(" e ");
    }

    function bigNumberToWords(n, singular, plural) {
        if (n === 0) return "";
        if (n === 1) return singular;
        return `${lessThanThousandToWords(n)} ${plural}`;
    }

    let integerPart = Math.floor(num);
    let decimalPart = Math.round((num - integerPart) * 100); // Get decimal part

    let words = [];
    const millions = Math.floor(integerPart / 1000000);
    if (millions > 0) {
        words.push(bigNumberToWords(millions, "um milhão", "milhões"));
        integerPart %= 1000000;
    }

    const thousands = Math.floor(integerPart / 1000);
    if (thousands > 0) {
        words.push(thousands === 1 ? "mil" : `${lessThanThousandToWords(thousands)} mil`);
        integerPart %= 1000;
    }

    if (integerPart > 0) {
        words.push(lessThanThousandToWords(integerPart));
    }

    let currencyWord = integerPart === 1 ? currencyNames[currency].singular : currencyNames[currency].plural;
    let result = words.join(" e ").toUpperCase() + ` ${currencyWord}`;

    // Handle decimal part (cêntimos, avos, etc.), except for JPY
    if (decimalPart > 0 && currency !== "JPY") {
        result += ` E ${lessThanThousandToWords(decimalPart).toUpperCase()} ${currencyNames[currency].centPlural}`;
    }

    return result;
}
